import { createSelector } from "reselect";
import { formValueSelector } from "redux-form";
import moment from "moment";

function formatDate(d) {
  return moment(d).format("YYYY-MM-DD");
}

// ===============================================
// ============= STATE GETTERS ===================
// ===============================================
const isRoundTrip = state =>
  formValueSelector("landingPageForm")(state, "trip_type") === "round_trip";
const getPreferredCabin = state => state.landingPage.preferredCabin;
const getPassengers = state => state.landingPage.passengers;
const getDepartDate = state =>
  formatDate(formValueSelector("landingPageForm")(state, "depart_date"));
const getReturnDate = state =>
  formatDate(formValueSelector("landingPageForm")(state, "return_date"));
const getToLocation = state =>
  formValueSelector("landingPageForm")(state, "location_to"); 
const getFromLocation = state =>
  formValueSelector("landingPageForm")(state, "location_from");
const getRawDepartDate = state =>
  formValueSelector("landingPageForm")(state, "depart_date");
const getRawReturnDate = state =>
  formValueSelector("landingPageForm")(state, "return_date");

// ===============================================
// ============= SELECTORS =======================
// ===============================================

// Selected trip, formatted for submission to fwdlook db
export const getLandingPageFormValues = createSelector(
  [
    isRoundTrip,
    getPreferredCabin,
    getPassengers,
    getDepartDate,
    getReturnDate,
    getToLocation,
    getFromLocation,
    getRawDepartDate,
    getRawReturnDate
  ],
  (
    isRoundTrip,
    preferredCabin,
    passengers,
    departDate,
    returnDate,
    to,
    from,
    rawDepartDate,
    rawReturnDate
  ) => {
    return {
      isRoundTrip,
      preferredCabin,
      passengers,
      departDate,
      returnDate,
      to,
      from,
      rawDepartDate,
      rawReturnDate
    };
  }
);



// WEBPACK FOOTER //
// ./src/data/landingPageForm/selectors.js